export function getOdometerFormat(value: any) {
  const str = String(value)

  if (!str.includes('.')) {
    return '(,ddd)'
  }

  const decimalDigits = str.split('.')[1].length
  return '(,ddd).' + 'd'.repeat(decimalDigits)
}
